import { Action } from '@ngrx/store';
import { IProductRequest } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/product.model';
import { ProductsResponseOP } from '@cemex-core/cmx-api';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';

export const OP_PRODUCT_RESET = '[Bulk CEM UL Modify - Product] Reset state';
export const OP_PRODUCT_LOAD = '[Bulk CEM UL Modify - Product] Load';
export const OP_PRODUCT_LOAD_COMPLETE = '[Bulk CEM UL Modify - Product] Load Complete';
export const OP_PRODUCT_LOAD_FAIL = '[Bulk CEM UL Modify - Product] Load Fail';
export const OP_PRODUCT_ADD_ENTITY = '[Bulk CEM UL Modify - Product] Add Entity';

export class ProductResetStateAction implements Action {
  readonly type = OP_PRODUCT_RESET;

  constructor(public payload = null) {}
}

export class ProductLoadAction implements Action {
  readonly type = OP_PRODUCT_LOAD;

  constructor(public payload: IProductRequest) {}
}

export class ProductLoadCompleteAction implements Action {
  readonly type = OP_PRODUCT_LOAD_COMPLETE;

  constructor(public payload: ProductsResponseOP) {}
}

export class ProductLoadFailAction implements Action {
  readonly type = OP_PRODUCT_LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class ProductModifyAddEntityAction implements Action {
  readonly type = OP_PRODUCT_ADD_ENTITY;
  constructor(public payload: IProduct) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type ProductActions =
  | ProductLoadAction
  | ProductResetStateAction
  | ProductLoadFailAction
  | ProductLoadCompleteAction
  | ProductModifyAddEntityAction;
